import { render, staticRenderFns } from "./TangkapDpk.vue?vue&type=template&id=5a506b07&"
import script from "./TangkapDpk.vue?vue&type=script&lang=js&"
export * from "./TangkapDpk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports